<template>
    <v-container fluid fill-height>
        <loading v-if="loading"></loading>
        <no-data v-else-if="contractorOrganisations.length == 0" message="Unable to load contractor organisations"></no-data>
        <no-data v-else-if="teams.length == 0" message="Unable to load teams"></no-data>
        <v-layout v-else>
            <v-flex>
                <v-card>
                    <v-layout pa-2>
                        <crop-work-export
                            :contractorOrganisations="contractorOrganisations"
                            :teams="teams">
                        </crop-work-export>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Loading from '@/components/generic/Loading.vue';
import NoData from '@/components/generic/NoData.vue';
import CropWorkExport from '@/components/preceda/CropWorkExport.vue'

export default {
    components: {
        Loading,
        NoData,
        CropWorkExport
    },
    data(){
        return {
            loading: false
        };
    },
    computed: {
        contractorOrganisations(){
            return this.$store.getters["PrecedaStore/getContractorOrganisations"];
        },
        teams(){
            return this.$store.getters["PrecedaStore/getTeams"];
        }
    },
    methods: {
        async loadData(){
            this.loading = true;

            await this.$store.dispatch("PrecedaStore/loadContractorOrganisations");
            await this.$store.dispatch("PrecedaStore/loadTeams");

            this.loading = false;
        }
    },
    created() {
        this.loadData();
    }
}
</script>

<style>

</style>
